import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

export default function ResponseFieldFilter({
  inputs,
  setInputs,
  typesList = [
    {
      value: "accepted",
      title: "Accepted",
    },
    {
      value: "pending",
      title: "Pending",
    },
    {
      value: "rejected",
      title: "Rejected",
    },
  ],
}) {
  // const [typesList, setTypesList] = useState([
  //   {
  //     value: "accepted",
  //     title: "Accepted",
  //   },
  //   {
  //     value: "pending",
  //     title: "Pending",
  //   },
  //   {
  //     value: "rejected",
  //     title: "Rejected",
  //   },
  // ]);

  const findObjectWithId = (id, list) => {
    return list.find((obj) => obj.value == id) || null;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    let obj = findObjectWithId(value, typesList);
    setInputs((old) => ({ ...old, [name]: obj }));
  };

  return (
    <>
      <div>
        <h6>Select Response Type</h6>

        <FormControl fullWidth required className="mt-2">
          <InputLabel id="sector-select-response">Response Type</InputLabel>
          <Select
            labelId="sector-select-response"
            id="sector-select-response"
            value={inputs?.response?.value || "all"}
            required
            name="response"
            label="Response Type"
            onChange={(e) => handleChange(e)}
          >
            <MenuItem key={"All"} value={"all"}>
              {"All"}
            </MenuItem>
            {typesList.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </>
  );
}
